import React from 'react';
import { autobind } from 'core-decorators';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  Row,
  Col,
  Spinner,
} from 'reactstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import qs from 'query-string';
import history from 'src/history';
import Alert from 'src/componentes/message-box/alert';

import { getConfiguration } from 'src/services/commonRequests';
import Edit from 'src/componentes/edit/edit-dialog';
import ContentManager from 'src/componentes/content-manager';
import Tabs from 'src/componentes/tabs/tabs';
import Tab from 'src/componentes/tabs/tab';
import { capitalizeFirstLetter, lowerCaseFirstLetter } from 'src/utils/string';
import ValidarRestricaoNovo from 'src/componentes/validar-restricao-novo/ValidarRestricao';
import errorHandler from 'src/utils/error-handler';
import LucideIcon from 'src/componentes/lucide-icon';
import DropdownItemRisco from 'src/paginas/gestao-risco/risco/RiscoListView/DropdownItemRisco';
import Acao from 'src/paginas/NewGantt';
import Button from 'src/componentes/button';
import PanelCollapse from 'src/componentes/panel-collapse';

import RiscoAvaliacao from '../Avaliacao/AvaliacaoListView';
import Resumo from './Resumo';
import RiscoPontosProblematicos from './RiscoPontoControleListView';
import Graficos from '../RiscoEditView/grafico/graficos';
import Schema from './Schema';
import EventoListView from '../Evento/EventoListView';
import http from 'src/services/httpService';
import {
  TIPO_INTERACAO_SOPHIE,
  ADDONS,
  TIPO_VALOR,
  STATUS_ITEM,
} from 'src/utils/constants';
import Permissao from 'src/paginas/permissao';
import RiscoAvaliacaoPowerBIListView from 'src/paginas/gestao-risco/risco/RiscoEditView/RiscoAvaliacaoPowerBI/RiscoAvaliacaoPowerBIListView';

const AssistenteVirtual = React.lazy(() =>
  import('src/components/IA/ChatGPT/AssistenteVirtual')
);

let disabled;

@autobind
class FormEdit extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      saved: false,
    };
  }

  handleCallBack() {
    this.setState({
      saved: !this.state.saved,
    });
  }

  atualizarComponentsComKeyRandomico() {
    this.props.model.getModel('randomAcaoKey').requestChange &&
      this.props.model.getModel('randomAcaoKey').requestChange(Math.random());
  }

  atualizarResumo() {
    this.props.model.getModel('forceRefresh').requestChange(Math.random());
  }

  atualizarCausas = (causasAtualizadas) => {
    if (this.props.model && causasAtualizadas) {
      this.props.model.getModel('causasRisco').requestChange(causasAtualizadas);
    }
  };

  atualizarConsequencias = (consequenciasAtualizadas) => {
    if (this.props.model && consequenciasAtualizadas) {
      this.props.model
        .getModel('consequenciasRisco')
        .requestChange(consequenciasAtualizadas);
    }
  };

  //handleClose - Parametros não usados do edit-dialog (a,b,c,d,e)
  onClose({ closeModal }) {
    if (closeModal)
      this.props.handleCloseEdit && this.props.handleCloseEdit(closeModal);
  }

  closeModal() {
    this.props.handleCloseEdit && this.props.handleCloseEdit();
  }

  render() {
    const {
      model,
      resources,
      intl,
      disabledEdit,
      showDelete = true,
      addons,
    } = this.props;

    const id = model.getModel('id') && model.getModel('id').value;
    const permissions = model?.getModel('permissions')?.value;

    if (disabledEdit) disabled = disabledEdit;
    else {
      disabled = permissions ? !permissions.allowEdit : false;
    }

    const statusId = model.getModel('status').value?.id;
    const existeFluxoAprovacao = model.getModel('existeFluxoAprovacao')?.value;
    const fluxoConcluidoEmStatusEditavel =
      existeFluxoAprovacao &&
      [
        STATUS_ITEM.EM_PLANEJAMENTO,
        STATUS_ITEM.ATIVO,
        STATUS_ITEM.CONCLUIDO,
        STATUS_ITEM.SUSPENSO,
        STATUS_ITEM.CANCELADO,
      ].includes(statusId);
    const disabledPendenteAprovacao =
      model.getModel('pendenteAprovacao').value &&
      !fluxoConcluidoEmStatusEditavel;
    const reprovadoFluxoAprovacao =
      model.getModel('fluxoAprovacao').value &&
      statusId == STATUS_ITEM.REPROVADO_AGUARDANDO_SUBMISSAO;
    const reprovadoDefinitivoFluxoAprovacao =
      model.getModel('fluxoAprovacao').value &&
      statusId == STATUS_ITEM.REPROVADO;
    const rascunhoPendenteAprovacao =
      model.getModel('fluxoAprovacao').value &&
      !existeFluxoAprovacao &&
      statusId == STATUS_ITEM.EM_PLANEJAMENTO;
    const modelo =
      model.getModel('modeloRisco') && model.getModel('modeloRisco').value;

    const isEstrategico = modelo && modelo.id == 1 ? true : false;
    const isOperacional = modelo && modelo.id == 2 ? true : false;
    const isProjeto = modelo && modelo.id == 3 ? true : false;

    const { configuracao, configuracaoEvento } = this.props;

    const { habilitarCalculoDeScores, utilizarPermissoes } = configuracao || {};

    const modeloRisco = {
      isEstrategico: isEstrategico,
      isOperacional: isOperacional,
      isProjeto: isProjeto,
    };

    const allowDelete =
      showDelete &&
      model &&
      model.getModel('permissions').getModel('allowDelete').value;

    const isNew = !id || id < 0 || id === 0;

    const addonIntegracaoPowerBIAvaliacaoRisco =
      addons &&
      addons.find((m) => m.id === ADDONS.INTEGRACAO_POWERBI_AVALIACAORISCO)
        ?.ativo;

    return (
      <div data-testid="risco-edit-form" style={{ marginTop: 15 }}>
        {isNew ? (
          <Resumo
            modeloRisco={modeloRisco}
            model={model}
            disabled={disabled}
            configuracao={configuracao}
          />
        ) : (
          <Tabs>
            <Tab key="1" label={<FormattedMessage id="cadastro" />}>
              <Resumo
                modeloRisco={modeloRisco}
                model={model}
                disabled={
                  disabled ||
                  disabledPendenteAprovacao ||
                  reprovadoDefinitivoFluxoAprovacao
                }
                rascunhoPendenteAprovacao={rascunhoPendenteAprovacao}
                configuracao={configuracao}
              />
            </Tab>
            {!isNew && (
              <Tab
                key="4"
                label={capitalizeFirstLetter(resources.analisederisco)}
              >
                <RiscoPontosProblematicos
                  modeloRisco={modeloRisco}
                  model={model}
                  disabled={
                    disabledEdit ||
                    disabled ||
                    disabledPendenteAprovacao ||
                    reprovadoDefinitivoFluxoAprovacao
                  }
                  configuracao={configuracao}
                  handleClose={this.onClose}
                  causasRisco={model.getModel('causasRisco').value}
                  consequenciasRisco={
                    model.getModel('consequenciasRisco').value
                  }
                  onCausasUpdated={this.atualizarCausas}
                  onConsequenciasUpdated={this.atualizarConsequencias}
                  riscoId={id}
                />
              </Tab>
            )}
            {!isNew &&
              !reprovadoDefinitivoFluxoAprovacao &&
              !reprovadoFluxoAprovacao &&
              !disabledPendenteAprovacao &&
              !rascunhoPendenteAprovacao && (
                <Tab
                  key="2"
                  label={capitalizeFirstLetter(resources.avaliacoes)}
                >
                  <PanelCollapse
                    header={capitalizeFirstLetter(resources.avaliacoes)}
                  >
                    <RiscoAvaliacao
                      showDelete={allowDelete}
                      showPage={false}
                      showSearch={false}
                      exibirAcao={true}
                      showNew={true}
                      parameters={{ riscoId: id }}
                      model={model}
                      disabled={disabled}
                      funcAtualizarAnscestral={
                        this.atualizarComponentsComKeyRandomico
                      }
                      refreshHeaderCustom={this.props.refreshHeaderCustom}
                      refreshResumo={this.atualizarResumo}
                      habilitarCalculoDeScores={habilitarCalculoDeScores}
                      habilitarLinkRisco={false}
                      configuration={configuracao}
                      habilitarBotaoSincronizarAvaliacoes={
                        model.getModel('utilizarValorPowerBI').value
                      }
                    />
                  </PanelCollapse>
                  {addonIntegracaoPowerBIAvaliacaoRisco &&
                    model.getModel('utilizarValorPowerBI').value && (
                      <PanelCollapse
                        header={intl.formatMessage({ id: 'label.integracao' })}
                      >
                        <RiscoAvaliacaoPowerBIListView
                          parameters={{
                            itemId: id,
                            tipoValorId: TIPO_VALOR.REALIZADO,
                            alterado: false,
                            utilizarConfigPeriodo: false,
                          }}
                        />
                      </PanelCollapse>
                    )}
                </Tab>
              )}
            {!isNew &&
              !reprovadoDefinitivoFluxoAprovacao &&
              !reprovadoFluxoAprovacao &&
              !disabledPendenteAprovacao &&
              !rascunhoPendenteAprovacao &&
              configuracao.habilitarAcompanhamentoEventosRisco && (
                <Tab
                  key={'6'}
                  label={intl.formatMessage(
                    { id: 'eventosRisco' },
                    { eventosderisco: resources.eventosderisco }
                  )}
                >
                  <EventoListView
                    showDelete={allowDelete}
                    showPage={false}
                    showSearch={false}
                    exibirAcao={true}
                    showNew={true}
                    parameters={{ riscoId: id }}
                    model={model}
                    disabled={disabled}
                    configuracao={configuracaoEvento}
                  />
                </Tab>
              )}
            {!isNew &&
              !reprovadoDefinitivoFluxoAprovacao &&
              !reprovadoFluxoAprovacao &&
              !disabledPendenteAprovacao &&
              !rascunhoPendenteAprovacao && (
                <Tab
                  //força children dessa tab a ser re renderizado, atualizando o estado
                  key={
                    (model.getModel('randomAcaoKey') &&
                      model.getModel('randomAcaoKey').value) ||
                    '5'
                  }
                  label={capitalizeFirstLetter(resources.planodeacao)}
                >
                  <Acao
                    itemId={id}
                    handleCloseModal={this.closeModal}
                    desabilitarSincronizacao={true}
                  />
                </Tab>
              )}
            {!isNew &&
              utilizarPermissoes &&
              !disabledPendenteAprovacao &&
              !reprovadoDefinitivoFluxoAprovacao &&
              !reprovadoFluxoAprovacao &&
              !rascunhoPendenteAprovacao &&
              permissions != null &&
              permissions.allowEditPermissions && (
                <Tab
                  label={<FormattedMessage id="label.permissoesDeAcesso" />}
                  key="7"
                >
                  <Row>
                    <Col md={12}>
                      <Permissao
                        parameters={{
                          itemId: id,
                          TipoItemId: 6,
                        }}
                        disabled={disabled}
                        showPanel={false}
                      />
                    </Col>
                  </Row>
                </Tab>
              )}
          </Tabs>
        )}
      </div>
    );
  }
}

@autobind
class RiscoEdit extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      id: this.props.location && qs.parse(this.props.location.search).id,
      dropdownOpen: false,
      configuracao: {},
      configuracaoEvento: {},
      forceRefresh: false,
      enviandoAprovacao: false,
    };

    this.enviandoAprovacaoRef = false;
  }

  componentDidMount() {
    getConfiguration('ItemConfiguracaoRisco')((configuracao) =>
      this.setState((prevState) => ({ ...prevState, configuracao }))
    )();
    getConfiguration('EventoRiscoConfiguracao')((configuracaoEvento) =>
      this.setState((prevState) => ({ ...prevState, configuracaoEvento }))
    )();
  }

  toggle() {
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  }

  handleSaved(data) {
    this.setState({ id: data.id });

    this.props.afterSave && this.props.afterSave(data);
  }

  handleCloseEdit(saved) {
    if (saved) this.setState({ saved: !this.state.saved });
  }

  refreshHeaderCustom = () => {
    this.setState({
      ...this.state,
      updater: Math.random(),
    });
  };

  async handleDeleteClick(item) {
    try {
      const parametros = { id: item.id };
      const response = await http.post('/Risco/ValidarRestricoes', parametros);
      const model = response.data;

      ContentManager.addContent(
        <ValidarRestricaoNovo
          title="labelExcluirRisco"
          url="/Risco/ValidarRestricoes"
          urlExclusao="/Risco/AtualizarStatusExcluido"
          urlList={this.props.urlList ?? '/gerenciar/Risco'}
          item={item}
          onClose={this.handleCloseEdit}
          labelCancelar="label.cancelar"
          labelAlterar="label.excluir"
          restricoesModel={model}
        />
      );
    } catch (error) {
      errorHandler(error);
    }
  }

  async handleAssistenteVirtualClick() {
    const { user, intl, resources, model, item } = this.props;
    const id =
      this.state.id ||
      item?.id ||
      (model && model.getModel('id') && model.getModel('id').value);

    const infoPrompt = await http.post(`/Risco/GetInfoInsight`, {
      riscoId: id,
    });

    const promptCausas = intl
      .formatMessage({ id: 'promptInsightRisco' })
      .replace(
        /{risco}|{riscos}|{NomeDoRisco}|{AreaDoRisco}|{ProbabilidadeResidual}|{ImpactoResidual}|{TratamentoDefinido}|{PlanoDeAcao}|{ListagemCausas}|{ListagemConsequências}|{ListaControlesPreventivos}|{ListaControlesCorretivos}/gi,
        function (matched) {
          switch (matched) {
            case '{risco}':
              return resources.risco;
            case '{riscos}':
              return resources.riscos;
            case '{NomeDoRisco}':
              return infoPrompt?.data?.nomeDoRisco;
            case '{AreaDoRisco}':
              return infoPrompt?.data?.areaDoRisco;
            case '{ProbabilidadeResidual}':
              return infoPrompt?.data?.probabilidadeResidual;
            case '{ImpactoResidual}':
              return infoPrompt?.data?.impactoResidual;
            case '{TratamentoDefinido}':
              return infoPrompt?.data?.tratamentoDefinido;
            case '{PlanoDeAcao}':
              return infoPrompt?.data?.planoDeAcao;
            case '{ListagemCausas}':
              return infoPrompt?.data?.listagemCausas;
            case '{ListagemConsequências}':
              return infoPrompt?.data?.listagemConsequências;
            case '{ListaControlesPreventivos}':
              return infoPrompt?.data?.listaControlesPreventivos;
            case '{ListaControlesCorretivos}':
              return infoPrompt?.data?.listaControlesCorretivos;
          }
        }
      );

    const msgConsultoraVirtualActioDesvio = intl
      .formatMessage({
        id: 'labelRiscos',
      })
      .replace('{riscos}', capitalizeFirstLetter(resources.riscos));

    ContentManager.addContent(
      <AssistenteVirtual
        user={user}
        prompt={promptCausas}
        title={msgConsultoraVirtualActioDesvio}
        interactionType={TIPO_INTERACAO_SOPHIE.INSIGHTS_RISCO}
      />
    );
  }

  handleCloseEditUrl() {
    const { from } = this.props.location.state || {};

    if (from) history.push(from);
    else history.push(`/gerenciar/risco`);
  }

  async handleEnviarParaAprovacao(
    model,
    isNew,
    formValid,
    showAllErrors,
    handleClose
  ) {
    if (this.enviandoAprovacaoRef) return;

    if (!formValid) {
      showAllErrors();
      return;
    }

    this.enviandoAprovacaoRef = true;
    this.setState({ enviandoAprovacao: true });

    try {
      await http.post(`Risco/EnviarParaAprovacao`, {
        model,
        parameters: { enviarParaAprovacao: true },
        isNew,
      });

      this.setState({ forceRefresh: true });

      ContentManager.addContent(
        <Alert
          message={this.props.intl.formatMessage(
            { id: 'labelEnvioRiscoAprovacaoSucesso' },
            { risco: this.props.resources.risco }
          )}
          type="success"
          handleClose={handleClose}
        />
      );
    } catch (error) {
      errorHandler(error);

      this.enviandoAprovacaoRef = false;
      this.setState({ enviandoAprovacao: false });
    }
  }

  renderButtonsEnd(
    model,
    isNew,
    formValid,
    showAllErrors,
    handleClose,
    handleSaveBeforeSave,
    isLoading
  ) {
    const statusId = Number(model?.status?.id);
    const aguardandoPrimeiroEnvioAprovacao =
      statusId === STATUS_ITEM.EM_PLANEJAMENTO && !model?.existeFluxoAprovacao;
    const aguardandoReenvioAprovacao =
      statusId === STATUS_ITEM.REPROVADO_AGUARDANDO_SUBMISSAO;
    const podeEnviarParaAprovacao =
      (aguardandoPrimeiroEnvioAprovacao || aguardandoReenvioAprovacao) &&
      model?.fluxoAprovacao &&
      model?.pendenteAprovacao == false;

    if (!podeEnviarParaAprovacao) {
      return [];
    }

    const { enviandoAprovacao } = this.state;

    return [
      <Button
        key="btnEnviarParaAprovacao"
        disabled={!formValid || enviandoAprovacao || isLoading}
        onClick={() =>
          this.handleEnviarParaAprovacao(
            model,
            isNew,
            formValid,
            showAllErrors,
            handleClose
          )
        }
        className="mr-2"
      >
        <div className="d-flex align-items-center">
          <div className={enviandoAprovacao ? 'pr-1' : ''}>
            {this.props.intl.formatMessage({ id: 'enviarParaAprovacao' })}
          </div>
          {enviandoAprovacao && <Spinner color="light" size="sm" />}
        </div>
      </Button>,
    ];
  }

  showErrorsCustom(formValue) {
    const aguardandoPrimeiroEnvioAprovacao =
      formValue.status?.id == STATUS_ITEM.EM_PLANEJAMENTO &&
      !formValue.existeFluxoAprovacao;

    if (
      formValue.fluxoAprovacao &&
      (formValue.pendenteAprovacao ||
        formValue.status?.id == STATUS_ITEM.REPROVADO ||
        aguardandoPrimeiroEnvioAprovacao)
    )
      return false;

    const { resources, intl } = this.props;

    if (
      this.state.configuracao?.associacaoControleCausaConsequenciaObrigatoria
    ) {
      const hasCausaComControle =
        formValue.causasRisco &&
        Array.isArray(formValue.causasRisco) &&
        formValue.causasRisco.some(
          (causa) =>
            causa.hasChildren || (causa.children && causa.children.length > 0)
        );

      const hasConsequenciaComControle =
        formValue.consequenciasRisco &&
        Array.isArray(formValue.consequenciasRisco) &&
        formValue.consequenciasRisco.some(
          (consequencia) =>
            consequencia.hasChildren ||
            (consequencia.children && consequencia.children.length > 0)
        );

      // Se não houver pelo menos 1 causa && 1 consequência com controle, exibe a mensagem
      if (!hasCausaComControle || !hasConsequenciaComControle) {
        ContentManager.addContent(
          <Alert
            title={<FormattedMessage id="erro" />}
            message={capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'label.ObrigatorioVincularControleCausaConsequencia' },
                {
                  pontodecontrole: lowerCaseFirstLetter(
                    resources.pontodecontrole
                  ),
                }
              )
            )}
          />
        );
        return true;
      }
    }

    return false;
  }

  render() {
    const {
      resources,
      intl,
      item,
      showDelete = true,
      disabledEdit = false,
    } = this.props;

    const id = this.state.id;
    const isNew = !((id && id > 0) || (item && item.id > 0));

    const showActionsSave =
      item?.status?.id == STATUS_ITEM.REPROVADO ? false : true;

    return (
      <div>
        <Edit
          {...this.props}
          forceRefresh={this.state.forceRefresh}
          showExport={false}
          showActionsEnd={showActionsSave}
          showSaveClose={showActionsSave}
          showSave={showActionsSave}
          disabled={disabledEdit}
          showIconDelete={showDelete}
          handleClose={
            id > 0 ? this.handleCloseEditUrl : this.props.handleClose
          }
          resourceSophieToolTip={'tooltipSophieInsightRisco'}
          handleAssistenteVirtualClick={
            !isNew && this.handleAssistenteVirtualClick
          }
          renderButtonActions={
            this.state.configuracao?.usarFluxoAprovacaoBelt
              ? this.renderButtonsEnd
              : null
          }
          renderActions={(closeModal) => {
            return (
              <div className="d-inline" style={{ height: '20px' }}>
                <UncontrolledDropdown
                  group
                  direction="right"
                  className="ml-2 d-inline"
                  key="indicador"
                >
                  <DropdownToggle color="btn-outline-secondary">
                    <LucideIcon icon="dots-vertical" />
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItemRisco
                      handleCloseModal={closeModal}
                      showEdit={item?.permissions?.allowEdit}
                      exibirEdicao={item?.permissions?.allowEdit}
                      item={item}
                      resources={resources}
                    />
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div>
            );
          }}
          url="/Risco"
          parameters={{ tipoId: 6, ...this.props.parameters }}
          titleField="nome"
          title={
            !isNew
              ? capitalizeFirstLetter(resources.risco)
              : capitalizeFirstLetter(
                  intl.formatMessage(
                    { id: 'labelAdicionarRisco' },
                    { risco: lowerCaseFirstLetter(resources.risco) }
                  )
                )
          }
          styleTitle={{ fontSize: '22px', fontFamily: 'nunito' }}
          HeaderCustomComponent={<Graficos updater={this.state.updater} />}
          formComponent={FormEdit}
          width="85%"
          height="90%"
          minHeight="30%"
          schema={Schema}
          handleSaved={this.handleSaved}
          configuracao={this.state.configuracao}
          configuracaoEvento={this.state.configuracaoEvento}
          id={id}
          item={
            this.props.item ? this.props.item : id && id > 0 ? { id: id } : null
          }
          showDelete={showDelete}
          onDeleting={this.handleDeleteClick}
          resources={resources}
          showErrorsCustom={this.showErrorsCustom}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
    moduloInteligenciaArtificial: state.user.moduloInteligenciaArtificial,
    user: state.user,
    addons: state.user.addonsDisponiveis,
  };
}

export default injectIntl(connect(mapStateToProps)(RiscoEdit));
